"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

import { appendQueryparams } from "apps/website/utils/misc/merge-query";

import { useAuth } from "./useAuth";

export function useRedirectIfLoggedIn(redirectTo = "/") {
  const auth = useAuth();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (auth.loggedIn) {
      const filteredParams = new URLSearchParams();
      searchParams.forEach((value, key) => {
        if (key !== "postLogin") {
          filteredParams.set(key, value);
        }
      });
      const fullPath = appendQueryparams(redirectTo, filteredParams);
      // Note: we use window href instead of Next router because
      // of cross-application transitions
      // TODO sanitize URL to prevent redirect attacks
      //   see https://cheatsheetseries.owasp.org/cheatsheets/Unvalidated_Redirects_and_Forwards_Cheat_Sheet.html
      window.location.href = fullPath;
    }
  }, [ auth.loggedIn, redirectTo ]);
}
